import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import ManagementsList from './ManagementsList';

//redux
import { ToastContainer } from 'react-toastify';

const Managements = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Empresa', icon: 'icon-building-2' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Departamentos' links={breadcrumbLinks} icon={'icon-users-round'} />
					<ManagementsList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Managements;
